import pluralize from 'pluralize'

import type { ScreeningLimits } from '@/modules/tools/bankruptcy/hooks'
import { formatNumber } from '@/utils'
import { NeedMore } from '../NeedMore'

export const ScreeningsBudget = ({
  credits,
  creditsNextExpiry,
  outOfCredits,
}: ScreeningLimits) => {
  return (
    <p className="text-right text-muted-foreground text-sm" aria-live="polite">
      <span className="text-foreground">
        {formatNumber(credits)} screening {pluralize('credit', credits)}
      </span>
      {creditsNextExpiry && <>, renews {creditsNextExpiry}</>}
      {outOfCredits && (
        <>
          <br />
          <NeedMore limit="allowance" />
        </>
      )}
    </p>
  )
}
